/**
 *  app 交互（包括原生 App 和 RN App）
 */

import route from "./route";
import url from "./url";
export default { ...route,...url}
